import { render, staticRenderFns } from "./FxAlert.vue?vue&type=template&id=eff78194&"
import script from "./FxAlert.vue?vue&type=script&lang=js&"
export * from "./FxAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports